import { Wallet, ArrowDown, ArrowUp } from '@phosphor-icons/react';

export const BookingWalletBar = ({ walletData, formatCurrency }) => {
  if (!walletData) return null;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      <div className="bg-white border border-gray-200 p-4 rounded-lg" data-testid="wallet-balance-card">
        <div className="flex items-center gap-2 mb-1">
          <Wallet size={18} className="text-emerald-600" />
          <span className="text-xs text-gray-500">Distributor Balance</span>
        </div>
        <p className={`text-xl font-bold ${(walletData.total_balance || 0) >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
          {formatCurrency(walletData.total_balance)}
        </p>
      </div>
      <div className="bg-white border border-gray-200 p-4 rounded-lg" data-testid="total-debit-display">
        <div className="flex items-center gap-2 mb-1">
          <ArrowDown size={18} className="text-red-500" />
          <span className="text-xs text-gray-500">Total Debit</span>
        </div>
        <p className="text-xl font-bold text-red-600">{formatCurrency(walletData.total_debit)}</p>
      </div>
      <div className="bg-white border border-gray-200 p-4 rounded-lg" data-testid="total-credit-display">
        <div className="flex items-center gap-2 mb-1">
          <ArrowUp size={18} className="text-green-500" />
          <span className="text-xs text-gray-500">Total Credit</span>
        </div>
        <p className="text-xl font-bold text-green-600">{formatCurrency(walletData.total_credit)}</p>
      </div>
    </div>
  );
};
